export default __webpack_public_path__ + "static/media/greenArrowDown.744d46d9.svg";